module.exports = __webpack_public_path__ + "static/media/document-week10.f74a7398.pdf";